import React from "react";
import Typography from "../../../Unknown/Typography";
import Box from "../../../Unknown/Box";
import { GridColDef } from "../../../Unknown/DataGrid";
import { AppointmentRefund } from "../types";

type ColumnTranslations = {
  headerRefundedTo: string;
};

const getColumnRefundedTo = (params: {
  translations: ColumnTranslations;
  headerClassName: string;
}): GridColDef<AppointmentRefund, string> => {
  const { translations, headerClassName } = params;

  return {
    field: "customerName",
    disableColumnMenu: true,
    sortable: false,
    headerName: translations.headerRefundedTo,
    flex: 1,
    headerClassName,
    renderCell: ({ row }) => {
      const { method } = row;

      const isCard = ["card", "card_present"].includes(method);
      const transactionId = isCard ? row.transactionId : "";

      return (
        <Box width="100%" overflow="hidden">
          <Typography
            variant="body2"
            color="text.primary"
            overflow="hidden"
            textOverflow="ellipsis"
            title={row.customerName}
          >
            {row.customerName}
          </Typography>
          <Typography
            variant="body2"
            fontSize={13}
            overflow="hidden"
            textOverflow="ellipsis"
            color="text.secondary"
            title={transactionId}
          >
            {transactionId}
          </Typography>
        </Box>
      );
    },
  };
};

export default getColumnRefundedTo;
